import { UUID } from '@/types/Id'

interface TemplatesQueryKeyArgs {
  orgId: UUID | ''
}

interface TemplateQueryKeyArgs {
  templateId: UUID | ''
}

export const templatesQueryKeys = {
  all: () => ['templates'] as const,
  organization: (keyArgs: TemplatesQueryKeyArgs) =>
    ['templates', keyArgs.orgId] as const,
  count: (keyArgs: TemplatesQueryKeyArgs) =>
    ['templates', keyArgs.orgId, 'count'] as const,
}

export const templateQueryKeys = {
  template: (keyArgs: TemplateQueryKeyArgs) =>
    ['template', keyArgs.templateId] as const,
}
